import {useSelector} from 'react-redux';
import {RootState} from '../../store';

export const useSettings = () => useSelector((state: RootState) => state.settings);
